import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";

export const PartnerAffiliationGridConfig = {
	grid: {
		gridId:'partnerAffiliationGrid',
		height: 0,
		groupable : false,
		editable : true,
		selectable : true,
		filterable : false,
		resizable : false,
		noRecords : true,
		reorderable : false,
		columnMenu : false,
		sortable : false,
		pageable:false,
		edit:false,
		delete: true,
		save: true,
	},
	list: BaseModelPartnerAffiliation.list,
	columns: BaseModelPartnerAffiliation.columns
}

